import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDownRounded';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useProjectInfoContext from '../../../../Contexts/ProjectContexts/ProjectInfoContext/useProjectInfoContext';
import SelectProjectLanguage from './Components/SelectProjectLanguage';
import SelectProjectMenu from './Components/SelectProjectMenu';
import StyledButton from './styles';

export default function ProjectButton() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t } = useTranslation();
  const { projects, project } = useProjectInfoContext();

  const current = project ?? { name: t('header.title') };

  return (
    <>
      <StyledButton
        className={clsx('project', { active: !!anchorEl })}
        onClick={(e) => { setAnchorEl((prev) => (prev ? null : e.currentTarget)); }}
        data-testid="select-project-button"
      >
        <div title={current.name}>
          {current.name}
        </div>
        <ArrowDropDownIcon />
      </StyledButton>
      <SelectProjectMenu
        anchorEl={anchorEl}
        onClose={() => { setAnchorEl(null); }}
        options={projects}
      />
      <SelectProjectLanguage />
    </>
  );
}
